import React from 'react'
import AboutUsPage from '../components/AboutUsPage'
import VisionMission from '../components/VisionMission'
import Aboutthi from '../components/Aboutthi'
import Count from '../components/Count'
import Directors from '../components/Directors'
import Discuss from '../components/Discuss'

const About = () => {
    return (
        <>
            <AboutUsPage />
            <Aboutthi />
            <Directors />
            <Discuss />
            <VisionMission />
            <Count />
        </>
    )
}

export default About
